import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function ChildSettingsPage() {
  const { user } = useAuth();

  return (
    <div>
      <div className="card hero-card" style={{ marginBottom: 20 }}>
        <div className="hero-title">Child Settings ⚙️</div>
        <div className="hero-subtitle">Manage your account info and app preferences.</div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header">
          <div className="card-title">Account</div>
        </div>
        <div style={{ display: 'grid', gap: 10, fontSize: 13 }}>
          <div><strong>Name:</strong> {user?.name || '-'}</div>
          <div><strong>Email:</strong> {user?.email || '-'}</div>
          <div><strong>Role:</strong> Child</div>
          <div><strong>Parent Linked:</strong> {user?.parentId ? 'Yes' : 'No'}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="card-title">Privacy Tips</div>
        </div>
        <div style={{ display: 'grid', gap: 10, fontSize: 13, color: 'var(--text-secondary)' }}>
          <div>• Keep permissions enabled only when needed.</div>
          <div>• Talk with your parent before changing privacy settings.</div>
          <div>• Use chat for quick support if anything feels wrong.</div>
        </div>
      </div>
    </div>
  );
}
